<app-section
  titleSection="Biens comparables vendus issus de la base Perval"
  [isLargeTitle]="true"
  [isActivated]="references.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-biens-comparables-vendus-read-mode
      [references]="references"
      [reportType]="reportType"
    >
    </app-biens-comparables-vendus-read-mode>
  </div>

  <div edit-mode>
    <app-biens-comparables-vendus-edit-mode
      [references]="references"
      [reportType]="reportType"
      (referencesChanged)="onReferencesChanged($event)"
    >
    </app-biens-comparables-vendus-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
